import { ItemsData, ItemsResponse, SingleItemData } from './types';
import { transformDTO as transformSingleItem } from '../../singleItem/slice/utils';

export const transformDTO: (data: ItemsResponse) => ItemsData = (
  data: ItemsResponse,
) => {
  const transformedItems: SingleItemData[] = data.items.map(item =>
    transformSingleItem(item),
  );

  return {
    items: transformedItems,
    hasMore: data.hasMore,
    totalCount: data.totalCount,
  };
};
